var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuotationMarkinline = function SvgQuotationMarkinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.617 0 1.975 9.506C.79 12.008 0 13.91 0 16.211c0 4.003 3.062 7.005 7.012 7.005 3.852 0 7.013-2.902 7.013-7.005 0-3.302-2.568-6.004-5.729-6.004h-.099L13.432 0H6.617Zm17.976 0L19.95 9.506c-1.186 2.502-1.976 4.403-1.976 6.705 0 4.003 3.062 7.005 7.013 7.005 3.852 0 7.012-2.902 7.012-7.005 0-3.302-2.568-6.004-5.728-6.004h-.1L31.408 0h-6.814Z",
    fill: "currentColor"
  })));
};
export default SvgQuotationMarkinline;